interface AISuggestionChipsProps {
  suggestions: string[];
  onSelect: (text: string) => void;
  disabled?: boolean;
}

export function AISuggestionChips({ suggestions, onSelect, disabled }: AISuggestionChipsProps) {
  if (!suggestions.length) return null;

  return (
    <div className="flex flex-wrap gap-1.5 px-4 py-2">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => onSelect(suggestion)}
          disabled={disabled}
          className="px-3 py-1.5 text-xs font-medium rounded-full border
            border-[var(--brand-primary)] border-opacity-30
            text-[var(--brand-primary)] bg-transparent
            hover:bg-[var(--brand-primary)] hover:bg-opacity-10
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-colors whitespace-nowrap"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
